module.exports = __webpack_public_path__ + "static/img/保险中介许可证0317.57742a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/保险中介许可证0317.jpg
// module id = f80v
// module chunks = 1